module.exports = __webpack_public_path__ + "assets/isolines-big-b7bf8b8606371ac4412f7535f0f2ab6b.png";